import { useState, useEffect, useContext, useRef  } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../redux/index';
import PageContext from '../sub-components/PageContext';
import HeaderBanner from '../sub-components/HeaderBanner.tsx';
import Footer from "../sub-components/Footer.tsx";
import AddNewSubCompanyRow from '../sub-components/AddNewSubCompanyRow';
import AddNewRebateSetupRow from '../sub-components/AddNewRebateSetupRow'; 
import AddNewPayoutInfoRow from '../sub-components/AddNewPayoutInfoRow';
import { HttpContext } from '../../api-services/HttpService';
import SnackbarAlert from '../sub-components/SnackbarAlert';
import AddNewAccountIdsModal from '../sub-components/AddNewAccountIdsModal'; 
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import CircularProgress from '@mui/material/CircularProgress';
import InputDataTable from '../sub-components/InputDataTableCopy.jsx';
import copyObjectToArray from '../functions/copyObjectToArray';
import { Link } from 'react-router-dom';
import MasterCompanyLevelInput from '../sub-components/MasterCompanyLevelInput.jsx';
import validateInputArray from '../functions/validateInputArray.js'; 
import dynamicValidation from '../functions/dynamicValidation.js';
import dynamicTransformation from '../functions/dynamicTransformation.js'; 
import RebateComponentInput from '../sub-components/RebateComponentInput.jsx';
import applyFilters from '../functions/applyFilters.js';
import standardFilter from '../functions/standardFilter.js';
import PageBreadcrumbs from '../sub-components/PageBreadcrumbs.jsx';
import ButtonComponent from '../sub-components/ButtonComponent.jsx';
import isNullOrUndefined from '../functions/isNullOrUndefined.js'; 
import { Typography } from '@mui/material';
import InputDataTableDynamic from '../sub-components/InputDataTableDynamicCopy.jsx'; 

const AddNewCompanyProfilePage = () =>{
    // initialize http context 
    const {
        GET, 
        POST, 
    } = useContext(HttpContext);
    // redux state for use of persistant state in different route (CompanyDetailsPage)
    const company = useSelector((state) => state.company);
    const companyInfo = useSelector((state) => state.companyInfo);
    const dispatch = useDispatch();
    const { setCompany, setCompanyInfo } = bindActionCreators(actionCreators, dispatch);
    // initialize states for company info 
    const [primaryCCRM, setPrimaryCCRM] = useState('');
    const [portfolio, setPortfolio] = useState();
    const [userList, setUserList] = useState([]);
    const [editButtonBool, setEditButtonBool] = useState(false);
    const [masterPayoutInfoBool, setMasterPayoutInfoBool] = useState(false); 
    const [setupToAllSubs, setSetupToAllSubs] = useState(false); 
    const [consortium, setConsortium] = useState(false); 
    const [companyType, setCompanyType] = useState(); 
    // initialize state for table dropdowns
    const [rebateSetupTypeList, setRebateSetupTypeList] = useState([]); 
    const [roleDescriptionList, setRoleDescriptionList] = useState([]);
    const [feeCategoryDescriptionList, setFeeCategoryDescriptionList] = useState([]);
    const [productTypeList, setProductTypeList] = useState([]);
    const [billingRateList, setBillingRateList] = useState([]);
    const [payoutMethodList, setPayoutMethodList] = useState([]);
    const [processorList, setProcessorList] = useState([]); 
    const [processorDefaultData, setProcessorDefaultData] = useState([]); 
    const [achAccountTypeList, setAchAccountTypeList] = useState([]); 
    const [fullFeeCategoryList, setFullFeeCategoryList] = useState([]); 
    // initialize state for sub company ids autocomplete
    const [subCompanyIdsList, setSubCompanyIdsList] = useState([]); 
    const [masterTierIdsList, setMasterTierIdsList] = useState([]); 
    // initialize states for tables
    const [activeList, setActiveList] = useState([{label: 'Active', id: "true"}, {label: 'Inactive', id: "false"}])
    const [subCompanyDataList, setSubCompanyDataList] = useState([]);
    const [subCompanyTableHeader, setSubCompanyTableHeader] = useState([]);
    const [subCompanyDataListLength, setSubCompanyDataListLength] = useState(0);
    const [rebateSetupDataList, setRebateSetupDataList] = useState({});
    const [rebateSetupTableHeader, setRebateSetupTableHeader] = useState([]);
    const [rebateSetupDataListLength, setRebateSetupDataListLength] = useState(0); 
    const [entitlementsDataList, setEntitlementsDataList] = useState([]     );
    const [entitlementsTableHeader, setEntitlementsTableHeader] = useState([]);
    const [payoutInfoDataList, setPayoutInfoDataList] = useState([]);
    const [payoutInfoTableHeader, setPayoutInfoTableHeader] = useState([]);
    const [payoutInfoDataListLength, setPayoutInfoDataListLength] = useState(0); 
    const [performanceBonusDataList, setPerformanceBonusDataList] = useState([]);
    const [performanceBonusTableHeader, setPerformanceBonusTableHeader] = useState([]);
    const [performanceBonusDataListLength, setPerformanceBonusDataListLength] = useState(0); 
    // initialize state for adding account ids to sub companies 
    const [showAddAccountIdsModal, setShowAddAccountIdsModal] = useState(false);
    const [accountIdsDataList, setAccountIdsDataList] = useState([]);
    const [accountIdsTableHeader, setAccountIdsTableHeader] = useState([]); 
    const [accountIdsRow, setAccountIdsRow] = useState(); 
    // initialize state for loading progress 
    const [showProgress, setShowProgress] = useState(false);
    // initialize state for rebate input type to determine incentiverate transformations
    const [rebateInputTypeId, setRebateInputTypeId] = useState(0);
    // initialize snackbar state
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarColor, setSnackbarColor] = useState('info');
    // initailize state lists for errors 
    const [subCompanyErrorList, setSubCompanyErrorList] = useState([{}]); 
    const [rebateSetupErrorList, setRebateSetupErrorList] = useState([{}]); 
    const [performanceBonusErrorList, setPerformanceBonusErrorList] = useState([{}]); 
    const [payoutInfoErrorList, setPayoutInfoErrorList] = useState([{}]); 
    // initialize state for errors
    const [editBillingRate, setEditBillingRate] = useState(true); 
    // initialize state for request loading 
    const [isLoading, setIsLoading] = useState(false); 
    // initialize state for master company level input configs 
    const [masterCompanyLevelConfig, setMasterCompanyLevelConfig] = useState([]); 
    const [masterCompanyLevelLists, setMasterCompanyLevelLists] = useState({
        incentiveid: [{label: '--select--', id: '--select--'}],
        consortiumid: [{label: '--select--', id: '--select--'}],
        primaryccrm: [], 
        companytypeid: [{label: '--select--', id: '--select--'}]
    });
    const [masterCompanyLevelValues, setMasterCompanyLevelValues] = useState({});
    const [masterCompanyLevelError, setMasterCompanyLevelError] = useState([{}]); 
        // state for true or false 
        const [trueObj, setTrueObj] = useState({label: 'Active', id: "true"}); 
        const [falseObj, setFalseObj] = useState({label: 'Inactive', id: "false"})
    // initialize stat for sub company level input configs 
    const [subCompanyLevelConfig, setSubCompanyLevelConfig] = useState([]); 
    const [subCompanyLevelLists, setSubCompanyLevelLists] = useState({
        active: [{label: '--select--', id: '--select--'}, {label: 'Active', id: "true"}, {label: 'Inactive', id: "false"}], 
        billingrateid: [{label: '--select--', id: '--select--'}]
    });
    // initialize state for rebate setup level input configs 
    const [rebateSetupConfig, setRebateSetupConfig] = useState([]); 
    const [rebateSetupLists, setRebateSetupLists] = useState({
        active: [{label: '--select--', id: '--select--'}, {label: 'Active', id: "true"}, {label: 'Inactive', id: "false"}], 
        billingrateid: [{label: '--select--', id: '--select--'}], 
        producttypeid: [{label: '--select--', id: '--select--'}], 
        feecategoryid: [{label: '--select--', id: '--select--'}], 
        rebatesetuptypeid: [{label: '--select--', id: '--select--'}]
    }); 
    // initialize state for payout info configs
    const [payoutInfoConfig, setPayoutInfoConfig] = useState([]); 
    const [payoutInfoLists, setPayoutInfoLists] = useState({
        active: [trueObj, falseObj], 
        payoutmethodid: [{label: '--select--', id: '--select--'}], 
        achaccounttype: [{label: '--select--', id: '--select--'}], 
        state: []
    }); 
    // initialize state for rebate components 
    const [rebateComponentConfig, setRebateComponentConfig] = useState([]); 
    const [fullRebateComponentConfig, setFullRebateComponentConfig] = useState([]); 
    const [rebateComponentValues, setRebateComponentValues] = useState({}); 
    const [rebateComponentError, setRebateComponentError] = useState([{}]); 
    // initialize ref for initial render 
    const initialRender1 = useRef(true); 

    // function wrapper to pass row component to datatable
    const AddNewSubCompanyRowComponent = (row, count, tableHeader) =>{
        return(
            <>
                <AddNewSubCompanyRow row={row} count={count} tableHeader={tableHeader}/>
            </>
        ); 
    } 

    // function wrapper to pass row component to datatable
    const AddNewRebateSetupRowComponent = (row, count, tableHeader) =>{
        return(
            <>
                <AddNewRebateSetupRow row={row} count={count} tableHeader={tableHeader}/>
            </>
        );
    } 

    // function wrapper to pass row component to datatable
    const AddNewPayoutInfoRowComponent = (data, setData, count, config, length, setLength ) => {
        return <AddNewPayoutInfoRow data={data} setData={setData} count={count} config={config} length={length} setLength={setLength} lists={payoutInfoLists} error={payoutInfoErrorList} setError={setPayoutInfoErrorList} />

    }

    // function to set snackbar state
    const snackbarAlert = (show, message, color) => {
        setSnackbarMessage(snackbarMessage => snackbarMessage = message);
        setSnackbarColor(snackbarColor => snackbarColor = color);
        setShowSnackbar(showSnackbar => showSnackbar = show);
    }

    // event handler for change to a field
    const onChange = () => {
        // update consortium flag
        if (masterCompanyLevelValues['incentiveid'] && masterCompanyLevelValues['incentiveid']['consortium'] == true) {
            setConsortium(consortium => consortium = true); 
        }
        else {
            setConsortium(consortium => consortium = false); 
        }
        // update portfolio
        if (masterCompanyLevelValues['incentiveid']) {
            setPortfolio(portfolio => portfolio = masterCompanyLevelValues['incentiveid']); 
        }
        // update primaryccrm 
        if (masterCompanyLevelValues['primaryccrm']) {
            setPrimaryCCRM(primaryCCRM => primaryCCRM = masterCompanyLevelValues['primaryccrm']); 
        }
        // update company type 
        if (!isNullOrUndefined(masterCompanyLevelValues['companytypeid'])) {
            setCompanyType(companyType => companyType = masterCompanyLevelValues['companytypeid']); 
        }
    }

    // event handler for submit click
    const onSubmitClick = () => {
        // validate and add mastercompanylevel data to request parameters 
        let masterCompanyLevelValuesRequest = [{...masterCompanyLevelValues}]; 
        // validate array
        let checkError = validateInputArray(
            masterCompanyLevelValuesRequest, 
            masterCompanyLevelConfig,
            dynamicValidation,
            masterCompanyLevelLists, 
            snackbarAlert,  
            masterCompanyLevelError, 
            setMasterCompanyLevelError, 
            dynamicTransformation, 
            { }
        ); 
        // don't run request if error
        if (checkError) {
            return; 
        }
        console.log('MasterCompanyLevel', masterCompanyLevelValuesRequest[0]); 
        // validate and add sub company level data to request args
        let companyIdsList = []; 
        let subCompanyDataListRequest = copyObjectToArray(subCompanyDataList); 
        // slice off last element of array for blank row 
        subCompanyDataListRequest = subCompanyDataListRequest.slice(0, subCompanyDataListRequest.length-1)
        // validate array
        checkError = validateInputArray(
            subCompanyDataListRequest, 
            subCompanyLevelConfig,
            dynamicValidation,
            subCompanyLevelLists, 
            snackbarAlert,  
            subCompanyErrorList, 
            setSubCompanyErrorList, 
            (row, config, args) => {
                // add companyids to list for other validations 
                companyIdsList.push(row['companyid']); 
                // run transformation on row 
                let temp = dynamicTransformation(row, config, args); 
                // remove index
                delete temp['index']; 
                // return transformed row 
                return temp; 
            }, 
            { }
        ); 
        // don't run request if error
        if (checkError) {
            return; 
        }
        console.log('SubCompanyLevel', subCompanyDataListRequest); 
        // create temp array for transformations before request 
        let rebateSetupDataListRequest = copyObjectToArray(rebateSetupDataList); 
        // slice off last element of array 
        rebateSetupDataListRequest = rebateSetupDataListRequest.slice(0, rebateSetupDataListRequest.length-1); 
        // validate array 
        checkError = validateInputArray(
            rebateSetupDataListRequest, 
            rebateSetupConfig,
            dynamicValidation,
            {
                ...rebateSetupLists, 
                companyid: {
                    override: setupToAllSubs, 
                    list: subCompanyIdsList 
                }, 
                masterincentivesetupid: masterTierIdsList
            }, 
            snackbarAlert,  
            rebateSetupErrorList, 
            setRebateSetupErrorList, 
            dynamicTransformation, 
            {
                incentiverate: {
                    rateTypeId: rebateInputTypeId,
                } 
            }
        ); 
        // don't run request if error
        if (checkError) {
            return; 
        }
        console.log('RebateSetups', rebateSetupDataListRequest);
        // validate consortium rebate components
        let rebateComponentValuesRequest = [{...rebateComponentValues}]; 
        checkError = false; 
        checkError = validateInputArray(
            rebateComponentValuesRequest,
            rebateComponentConfig, 
            dynamicValidation, 
            {}, 
            snackbarAlert, 
            rebateComponentError, 
            setRebateComponentError, 
            dynamicTransformation, 
            {}
        ); 
        // don't run request if error
        if (checkError) {
            return; 
        }
        console.log('RebateComponents', rebateComponentValuesRequest); 

        // create temp array for transformations  before request 
        let payoutInfoDataListRequest = copyObjectToArray(payoutInfoDataList); 
        // slice off last element for blank column 
        if (!masterPayoutInfoBool) {
            payoutInfoDataListRequest = payoutInfoDataListRequest.slice(0, payoutInfoDataListRequest.length-1); 
        }
        // validate array 
        checkError = validateInputArray(
            payoutInfoDataListRequest, 
            payoutInfoConfig,
            dynamicValidation,
            {
                ...payoutInfoLists, 
                companyid: {
                    override: masterPayoutInfoBool, 
                    list: subCompanyIdsList 
                }
            }, 
            snackbarAlert,  
            payoutInfoErrorList, 
            setPayoutInfoErrorList, 
            (row, config, args) => {
                // run transformation on row 
                let temp = dynamicTransformation(row, config, args); 
                // remove index
                delete temp['mastersetupbool']; 
                // return transformed row 
                return temp; 
            }, 
            { }
        ); 
        // don't run request if error
        if (checkError) {
            return; 
        }
        console.log('PayoutInfo', payoutInfoDataListRequest); 

        // show spinner on request button 
        setIsLoading(isLoading => isLoading = true); 
        // make post request to insert data into aurora db
        POST('/client/addNewCompanyData', {
            'GenerateMasterCompanyId': process.env.REACT_APP_GENERATE_MASTER_COMPANY_ID, 
            'MasterCompanyData': masterCompanyLevelValuesRequest[0], 
            'SubCompanyData': subCompanyDataListRequest, 
            'RebateSetupData': rebateSetupDataListRequest, 
            'PayoutInfoData': payoutInfoDataListRequest, 
            'RebateComponents': rebateComponentValuesRequest[0], 
            'RebateSetupToAllSubCompanies': setupToAllSubs,
            'EntitlementsData': entitlementsDataList
        }).then(res => { 
            console.log(res);
            // trigger success alert
            snackbarAlert(true, 'Successfully uploaded data.', 'success');
            // hide spinner
            setIsLoading(isLoading => isLoading = false); 
            // update redux persistant state and redirect to /CompanyDetailsPage
            setCompany(masterCompanyLevelValuesRequest[0]['mastercompanyname']);
            setCompanyInfo(masterCompanyLevelValuesRequest[0]);
            // if there is not a mastercompanyid in companyInfo assign from response
            if (isNullOrUndefined(masterCompanyLevelValuesRequest[0]['mastercompanyid'])) {
                masterCompanyLevelValuesRequest[0]['mastercompanyid'] = res['data']['mastercompanyid']; 
            }
            window.location = window.location.origin + '/CompanyDetailsPage'; 
        }).catch(err => {
            console.log(err);
            // show alert on error
            snackbarAlert(true, 'Error uploading data.', 'error');
            // hide spinner
            setIsLoading(isLoading => isLoading = false); 
        });
    }

    // get fee categories to show in dropdown based on company type selected
    const getFeeCategoryDisplay = (feeCategoryList) => {
        if (isNullOrUndefined(masterCompanyLevelValues) || isNullOrUndefined(masterCompanyLevelValues['companytypeid'])){
            return []; 
        }
        // add fee category ids for selected company type 
        let returnList = []; 
        for (let i = 0; i < feeCategoryList.length; i++){
            if (feeCategoryList[i]['companytypeid'] === masterCompanyLevelValues['companytypeid']['id']) {
                returnList.push(feeCategoryList[i]); 
            }
        }
        return returnList; 
    }

    // get all info from database to render
    const getAddNewCompanyData = () => {
        setShowProgress(showProgress => showProgress = true);
        return new Promise ((resolve, reject) => {
            GET('/client/addNewCompanyData', {}).then(res => {
                console.log(res);
                // set add new company state
                let temp = []; 
                for (let i = 0; i < res['data']['AddNewSubCompanyCols'].length; i++){
                    temp.push(res['data']['AddNewSubCompanyCols'][i]['columnname']);
                }
                setSubCompanyTableHeader(subCompanyTableHeader => subCompanyTableHeader = res['data']['AddNewSubCompanyCols']);
                // first element to add to data list 
                let temp1;
                [...temp].map((el) => {
                    if (el == 'blank'){
                        temp1 = {...temp1, [el]: true};
                    }
                    else{
                        temp1 = {...temp1, [el]: ''};
                    }
                });
                setSubCompanyDataList(subCompanyDataList => subCompanyDataList = {0: temp1});
                // set add new rebate setup state
                temp = [];
                for (let i = 0; i < res['data']['AddNewRebateSetupCols'].length; i++){
                    temp.push(res['data']['AddNewRebateSetupCols'][i]['columnname']);
                }
                setRebateSetupTableHeader(rebateSetupTableHeader => rebateSetupTableHeader = res['data']['AddNewRebateSetupCols']);
                // first element to add to list
                let temp2; 
                [...temp].map((el) => {
                    if (el == 'blank'){
                        temp2 = {...temp2, [el]: true};
                    }
                    else{
                        temp2 = {...temp2, [el]: ''};
                    }
                });
                setRebateSetupDataList(rebateSetupDataList => rebateSetupDataList = {0: temp2});
                // set add new entitlements state
                temp = [];
                for (let i = 0; i < res['data']['AddNewCompanyEntitlementsCols'].length; i++){
                    temp.push(res['data']['AddNewCompanyEntitlementsCols'][i]['columnname']);
                }
                setEntitlementsTableHeader(entitlementsTableHeader => entitlementsTableHeader = res['data']['AddNewCompanyEntitlementsCols']);
                // set add new payout info state
                setPayoutInfoTableHeader(payoutInfoTableHeader => payoutInfoTableHeader = res['data']['AddNewPayoutInfoCols']);
                setPayoutInfoDataList(payoutInfoDataList => payoutInfoDataList = {0: { blank: true} });
                // set edit button bool from user entitlement (only admin)
                setEditButtonBool(editButtonBool => editButtonBool = res['data']['UserEntitlement']);
                // set state for rebate setup row dropdowns
                setProductTypeList(productTypeList => productTypeList = [ ...res['data']['ProductTypeList']]);
                setFeeCategoryDescriptionList(feeCategoryDescriptionList => feeCategoryDescriptionList = getFeeCategoryDisplay(res['data']['FeeCategoryData']));
                setBillingRateList(billingRateList => billingRateList = [ ...res['data']['BillingRateList']]);
                setRebateSetupTypeList(rebateSetupTypeList => rebateSetupTypeList = [...res['data']['RebateSetupTypeList']]); 
                // set state for user entitlements row dropdowns
                setRoleDescriptionList(roleDescriptionList => roleDescriptionList = [ ...res['data']['UserRoleData']]);
                // set state for payout info row dropdown 
                setPayoutMethodList(payoutMethodList => payoutMethodList = [ ...res['data']['PayoutMethodList']]);
                setAchAccountTypeList(achAccountTypeList => achAccountTypeList = res['data']['AchAccountTypeList']); 
                // set state for addNewAccountIdsModal
                setAccountIdsTableHeader(accountIdsTableHeader => accountIdsTableHeader = res['data']['AddNewAccountIdsCols']); 
                setAccountIdsDataList(accountIdsDataList => accountIdsDataList = []); 
                // set state for rebate input type id to determine incentiverate transformations
                setRebateInputTypeId(rebateInputTypeId => rebateInputTypeId = res['data']['RebateInputTypeId']); 
                // set state for processor list and defaults
                setProcessorList(processorList => processorList = res['data']['ProcessorIdsList']); 
                setProcessorDefaultData(processorDefaultData => processorDefaultData = res['data']['RebateIncentiveData']); 
                // set state for input configs 
                setMasterCompanyLevelConfig(masterCompanyLevelConfig => masterCompanyLevelConfig = res['data']['MasterCompanyLevelConfig']); 
                setMasterCompanyLevelLists(masterCompanyLevelLists => masterCompanyLevelLists = {
                    ...masterCompanyLevelLists, 
                    incentiveid: res['data']['RebateIncentiveData'], 
                    consortiumid: res['data']['ConsortiumIdList'],
                    incentivefreq: res['data']['RebateFrequencyList'], 
                    companytypeid: res['data']['CompanyTypeList']
                }); 
                setSubCompanyLevelConfig(subCompanyLevelConfig => subCompanyLevelConfig = res['data']['SubCompanyLevelConfig']); 
                setSubCompanyLevelLists(subCompanyLevelLists => subCompanyLevelLists = { 
                    active: [{label: 'Active', id: "true"}, {label: 'Inactive', id: "false"}], 
                    billingrateid: res['data']['BillingRateList']
                }); 
                setRebateSetupConfig(rebateSetupConfig => rebateSetupConfig = res['data']['RebateSetupConfig']); 
                setRebateSetupLists(rebateSetupLists => rebateSetupLists = {
                    active: [{label: 'Active', id: "true"}, {label: 'Inactive', id: "false"}], 
                    billingrateid: res['data']['BillingRateList'], 
                    producttypeid: res['data']['ProductTypeList'], 
                    feecategoryid: getFeeCategoryDisplay(res['data']['FeeCategoryData']), 
                    rebatesetuptypeid: res['data']['RebateSetupTypeList']
                }); 
                setPayoutInfoConfig(payoutInfoConfig => payoutInfoConfig = res['data']['PayoutInfoConfig']); 
                setPayoutInfoLists(payoutInfoLists => payoutInfoLists = {
                    active: [trueObj, falseObj], 
                    payoutmethodid: res['data']['PayoutMethodList'], 
                    achaccounttype: res['data']['AchAccountTypeList'], 
                    state: res['data']['StateList']
                }); 
                // set state for rebate components 
                setFullRebateComponentConfig(fullRebateComponentConfig => fullRebateComponentConfig = res['data']['RebateComponentConfigs']); 
                // set state for fee category list 
                setFullFeeCategoryList(fullFeeCategoryList => fullFeeCategoryList = res['data']['FeeCategoryData']); 
                // hide loading skeletons and show table
                setShowProgress(showProgress => showProgress = false);
                resolve(res);
            }).catch(err => {
                setShowProgress(showProgress => showProgress = false);
                reject(err);
            });
        });
    }

    // get user info from users endpoint
    const getUserInfoData = () => {
        return new Promise((resolve, reject) => {
            GET('/user/inv/headers', {}).then(res => {
                let temp = [];
                // if user is active add to list
                for (let i = 0; i < res['data']['UserInventory']['Users'].length; i++){
                    if (res['data']['UserInventory']['Users'][i]['Enabled'] == true){
                        temp.push(res['data']['UserInventory']['Users'][i]['Username']);
                    }
                }
                // set userlist to render on screen
                setUserList(userList => userList = temp);
                setMasterCompanyLevelLists(masterCompanyLevelLists => masterCompanyLevelLists = {
                    ...masterCompanyLevelLists, 
                    primaryccrm: temp
                }); 
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        });
    }
    // useEffect for initial render
    useEffect(() => {
        // make initial get request to get display information from database
        getAddNewCompanyData().then(res => {
            console.log(res);
        }).catch(err => {
            console.log(err);
        });      
        // make get request to get user list from users endpoint
        getUserInfoData().then(res => {
            console.log(res);
        }).catch(err => {
            console.log(err);
        });
    }, []);

    // when primaryCCRM changes add to entitlements list as ccrm
    useEffect(() => {
        // set CCRM entitlement for primary ccrm 
        if (primaryCCRM != null && primaryCCRM.length > 0){
            setEntitlementsDataList(entitlementsDataList => entitlementsDataList = [
                {
                    active: true, 
                    userid: primaryCCRM, 
                    userroleid: process.env.REACT_APP_CCRM_ROLE_ID, 
                    blank: false, 
                }, 
            ]); 
        }
        else {
            setEntitlementsDataList(entitlementsDataList => entitlementsDataList = []); 
        }
        
    }, [primaryCCRM]); 

    // useEffect for masterPayoutInfoBool toggle
    useEffect(() => {
        // if masterPayoutInfoBool is true make one input row for master company 
        if (masterPayoutInfoBool){
            let temp2 = []; 
            for (let i = 0; i < payoutInfoTableHeader.length; i++){
                temp2.push(payoutInfoTableHeader[i]['columnname']);
            }
            let temp;
            temp2.map((el) => {
                if (el == 'blank'){
                    temp = {...temp, [el]: false};
                }
                else if (el == 'active'){
                    temp = {...temp, [el]: 'Active'};
                }
                else if (el == 'payoutmethoddescription' || el == 'achaccounttype'){
                    temp = {...temp, [el]: '--select--'};
                }
                else if (el == 'companyid'){
                    temp = {...temp, [el]: process.env.REACT_APP_MASTER_PAYOUT_INFO_PLACEHOLDER}; 
                }
                else{
                    temp = {...temp, [el]: ''};
                }
            });
            setPayoutInfoDataList(payoutInfoDataList => payoutInfoDataList = [ temp ]);
        }
        // if changing back to sub company payout info reset payoutInfoDataList
        else {
            // set add new payout info state
            let temp = [];
            for (let i = 0; i < payoutInfoTableHeader.length; i++){
                temp.push(payoutInfoTableHeader[i]['columnname']);
            }
            //first element to add to data list
            let temp4 = {}; 
            temp.map((el) => {
                if (el == 'blank'){
                    temp4[el]= true;
                }
                else if (el == 'active')
                    temp4[el]= activeList[0]; 
                else {
                    temp4[el]= '';
                }
            });
            setPayoutInfoDataList(payoutInfoDataList => payoutInfoDataList = [ temp4 ]);
        }
    }, [masterPayoutInfoBool]); 

    // useEffect for setupToAllSubsChange
    useEffect(() => {
        // remove companyid from all elements of rebateSetupDataList
        let temp = rebateSetupDataList; 
        if (setupToAllSubs){
            for (let i = 0; i < temp.length; i++){
               temp[i]['companyid'] = null;  
            }
        }
        setRebateSetupDataList(rebateSetupDataList => rebateSetupDataList = temp); 
    }, [setupToAllSubs]); 

    // useEffect to filter Rebate Component Config on Incentive ID change 
    useEffect(() => {
        if (initialRender1.current == false && portfolio && portfolio['id']) {
            // specify function list for filters
            const functionList = [
                {function: standardFilter, value: portfolio['id'], flag: 1, cols: ['incentiveid']}
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(fullRebateComponentConfig, functionList);
            // update rebate config 
            setRebateComponentConfig(rebateComponentConfig => rebateComponentConfig = filteredList); 
        }
        else {
            initialRender1.current = false; 
        }
    }, [portfolio])

    // useEffect to filter fee category id options on company type change
    useEffect(() => {
        // set state 
        setFeeCategoryDescriptionList(feeCategoryDescriptionList => feeCategoryDescriptionList = getFeeCategoryDisplay(fullFeeCategoryList))
        // set list config 
        setRebateSetupLists(rebateSetupLists => rebateSetupLists = {
            ...rebateSetupLists, 
            feecategoryid: getFeeCategoryDisplay(fullFeeCategoryList), 
        }); 
        // clear fee categories input for rebates 
        let temp = rebateSetupDataList; 
        Object.keys(temp).map(el => { 
            if (el['blank'] === true) {
                el['feecategoryid'] = {id: '--select--', label: '--select--'}; 
            }
        }); 
        // set state 
        setRebateSetupDataList(rebateSetupDataList => rebateSetupDataList = temp); 
    }, [companyType]); 

    // object with variables to pass to context
    const settings = { 
        subCompanyDataList, 
        setSubCompanyDataList, 
        subCompanyTableHeader, 
        setSubCompanyTableHeader, 
        rebateSetupDataList, 
        setRebateSetupDataList, 
        rebateSetupTableHeader, 
        setRebateSetupTableHeader, 
        entitlementsDataList, 
        setEntitlementsDataList, 
        entitlementsTableHeader, 
        setEntitlementsTableHeader,
        payoutInfoDataList, 
        setPayoutInfoDataList, 
        payoutInfoTableHeader, 
        setPayoutInfoTableHeader,  
        performanceBonusDataList, 
        setPerformanceBonusDataList,
        performanceBonusTableHeader, 
        setPerformanceBonusTableHeader,  
        feeCategoryDescriptionList,  
        productTypeList, 
        billingRateList, 
        roleDescriptionList,  
        userList, 
        payoutMethodList, 
        showSnackbar, 
        setShowSnackbar, 
        snackbarMessage, 
        snackbarColor, 
        showAddAccountIdsModal, 
        setShowAddAccountIdsModal, 
        accountIdsDataList, 
        setAccountIdsDataList, 
        accountIdsTableHeader, 
        setAccountIdsTableHeader, 
        accountIdsRow, 
        setAccountIdsRow, 
        showProgress, 
        subCompanyIdsList, 
        setSubCompanyIdsList, 
        masterTierIdsList, 
        setMasterTierIdsList, 
        masterPayoutInfoBool, 
        setupToAllSubs,  
        subCompanyErrorList, 
        setSubCompanyErrorList, 
        rebateSetupErrorList, 
        setRebateSetupErrorList,
        payoutInfoErrorList, 
        setPayoutInfoErrorList,
        performanceBonusErrorList, 
        setPerformanceBonusErrorList, 
        processorList, 
        processorDefaultData, 
        portfolio, 
        editBillingRate,
        setEditBillingRate, 
        rebateInputTypeId, 
        rebateSetupDataListLength, 
        setRebateSetupDataListLength, 
        subCompanyDataListLength, 
        setSubCompanyDataListLength, 
        payoutInfoDataListLength, 
        setPayoutInfoDataListLength, 
        performanceBonusDataListLength, 
        setPerformanceBonusDataListLength, 
        activeList, 
        rebateSetupTypeList, 
        achAccountTypeList, 
        companyType
    };

    return(
        <div class='summary-page'>
            {/* Wrap all children so they can access PageContext variables */}
            <PageContext.Provider value={ settings }>
                {/* header and navslider present on every page */}
                <HeaderBanner />
                {/* breadcrumbs */}
                <div className="pt-1 ps-3 ms-3">
                    <PageBreadcrumbs />
                </div>
                {/* show modal for adding accountids */}
                <AddNewAccountIdsModal/>
                {/* snackbar component for alerts */}
                <SnackbarAlert />
                {/* link button to navigate to add new company profile page */}
                <div className="container-fluid d-flex flex-column">
                    <div className="d-flex flex-column flex-grow-1 p-2">
                        {/* table to add payout info for sub companies */}
                        <div className="mb-3" style={{ borderRadius: '12px', background: '#fff' }}>
                            <div className='d-flex justify-content-between flex-wrap p-3'>
                                <div className='d-flex'>
                                    <Typography className='align-self-center'>Add New</Typography>
                                    <div>
                                        <Link
                                            to={{
                                                pathname: "/AddNewCompanyProfilePage",
                                            }}
                                        >
                                            <ButtonComponent
                                                tag={"Company Profile"}
                                                border={'#000 1px solid'}
                                                background={window.location.pathname === '/AddNewCompanyProfilePage' ? '#000' : '#fff'}
                                                color={window.location.pathname === '/AddNewCompanyProfilePage' ? '#fff' : '#001317'}
                                                width={'150px'}
                                            />
                                        </Link>
                                    </div>
                                    {process.env.REACT_APP_CONSORTIUM_MANAGEMENT === '1' ? 
                                    <div>
                                        <Link
                                            to={{
                                                pathname: "/AddConsortiumIdPage",
                                            }}
                                        >
                                            <ButtonComponent
                                                tag={"Consortium ID"}
                                                border={'#000 1px solid'}
                                                background={window.location.pathname === '/AddConsortiumIdPage' ? '#000' : '#fff'}
                                                color={window.location.pathname === '/AddConsortiumIdPage' ? '#fff' : '#001317'}
                                                width={'150px'}
                                            />
                                        </Link>
                                    </div>
                                    :<div></div>}
                                </div>
                            </div>
                            <hr style={{ margin: 0 }} />
                            {/* top label to input company info */}
                            <div className='d-flex gap-1 align-items-center p-3'>
                                <div className='flex-fill'>
                                    <MasterCompanyLevelInput values={masterCompanyLevelValues} setValues={setMasterCompanyLevelValues} config={masterCompanyLevelConfig} inputLists={masterCompanyLevelLists} error={masterCompanyLevelError} isLoading={showProgress} consortium={consortium} onChange={onChange} />
                                </div>
                                <div>
                                    {isLoading || showProgress ?
                                        <ButtonComponent border={'#fcd800 1px solid'} background={'#fcd800'} color={'#001317'}
                                            tag={<CircularProgress size='25px' sx={{ color: 'white', margin: '2.5px' }} />} />
                                        : editButtonBool && <ButtonComponent tag='Submit' border={'#fcd800 1px solid'} background={'#fcd800'} color={'#001317'} onButtonClick={() => onSubmitClick()} />}
                                </div>
                            </div>

                        </div>
                        {/* label for search column dropdown and search bar */}
                        <div className="mb-3 pb-3" style={{ borderRadius: '12px', background: '#fff' }}>
                            <Typography className="mb-3 ps-3 pt-3">Company IDs</Typography>
                            <InputDataTable RowComponent={AddNewSubCompanyRowComponent} tableHeader={subCompanyTableHeader} dataList={subCompanyDataList} showSpinner={showProgress} skeletonHeight='7vh' />
                        </div>
                        {/* table to add rebate setups */}
                        <div className="mb-3 pb-3" style={{ borderRadius: '12px', background: '#fff' }}>
                            <div className="d-flex mb-3 ps-3 pt-3">
                                <Typography className="me-3 align-self-center">Rebate Setup</Typography>
                                <div className="vr me-3 align-self-center" style={{ height: '1.5rem' }}></div>
                                <div className="d-flex flex-grow-1">
                                    <div>
                                        <FormControlLabel
                                            value="end"
                                            control={<Checkbox
                                                sx={{
                                                    color: '#000000',
                                                    '&.Mui-checked': {
                                                        color: '#000000',
                                                        fontFamily: 'Roboto Medium'
                                                    },
                                                }} />}
                                            label="Add Setup to all Sub Companies"
                                            labelPlacement="end"
                                            sx={{
                                                // color: 'black',
                                                fontFamily: 'Roboto medium'
                                                // margin: 'auto', 
                                            }}
                                            checked={setupToAllSubs}
                                            onChange={(e) => { setSetupToAllSubs(setupToAllSubs => setupToAllSubs = e.target.checked) }}
                                        />
                                    </div>
                                    <div class='label-text-span-right'>
                                        <text style={{ color: 'transparent' }}>---</text>
                                    </div>
                                </div>
                            </div>


                            <InputDataTable RowComponent={AddNewRebateSetupRowComponent} tableHeader={rebateSetupTableHeader} dataList={rebateSetupDataList} showSpinner={showProgress} skeletonHeight='7vh' />
                        </div>
                        {/* table to add rebate componennt */}
                        <div className="mb-3 pb-3" style={{ borderRadius: '12px', background: '#fff' }}>
                            <RebateComponentInput tag='Rebate Component' values={rebateComponentValues} setValues={setRebateComponentValues} config={rebateComponentConfig} errorList={rebateComponentError[0]} portfolioId={portfolio} />
                        </div>
                        {/* table to add payout info for sub companies */}
                        <div className="mb-3 pb-3" style={{ borderRadius: '12px', background: '#fff' }}>
                            <div className="d-flex mb-3 ps-3 pt-3">
                                <Typography className="me-3 align-self-center">Payout Info</Typography>
                                <div className="vr me-3 align-self-center" style={{ height: '1.5rem' }}></div>
                                <div className="d-flex flex-grow-1">
                                    <div>
                                        <FormControlLabel
                                            value="end"
                                            control={<Checkbox
                                                sx={{
                                                    color: '#000000',
                                                    '&.Mui-checked': {
                                                        color: '#000000',
                                                        fontFamily: 'Roboto medium'
                                                    },
                                                }} />}
                                            label="Master Company Payout Info"
                                            labelPlacement="end"
                                            sx={{
                                                // color: 'black',
                                                fontFamily: 'Roboto medium'
                                                // margin: 'auto', 
                                            }}
                                            checked={masterPayoutInfoBool}
                                            onChange={(e) => { setMasterPayoutInfoBool(masterPayoutInfoBool => masterPayoutInfoBool = e.target.checked) }}
                                        />
                                    </div>
                                    <div class='label-text-span-right'>

                                    </div>
                                </div>
                            </div>
                            <InputDataTableDynamic disableMaxTableHeight={true} RowComponent={AddNewPayoutInfoRowComponent} config={payoutInfoConfig} dataList={payoutInfoDataList} setDataList={setPayoutInfoDataList} showSpinner={showProgress} skeletonHeight='7vh' />
                        </div>
                    </div>
                </div>
                    <Footer cssClassName="footer-main-comp"/>
            </PageContext.Provider>
        </div> 
    );
}

export default AddNewCompanyProfilePage;